<div class="text_box">
  <h2>계정 영구 삭제</h2><hr>
  <p>회원님의 계정은 사이트에서 영구히 삭제되었습니다.<br>사이트 이용을 원하시면 아래 회원가입 버튼을 눌러 다른 아이디로 재가입해 주시기 바랍니다.</p>
  <div style="text-align: right;">
    <button mat-flat-button color="warn" routerLink="/kr/signup">회원가입</button>
  </div>
</div>
<div class="body_bg"></div>
